module.exports = __webpack_public_path__ + "static/media/plasm-logo.e814f1e5.png";